import { Dispatch } from "redux";
import { Action } from "app/pages/DiscountEditor/actionTypes";
import * as React from "react";
import { connect } from "react-redux";
import { getDiscountSaveStatus } from "app/pages/DiscountEditor/modules/Editor";
import { DiscountSaveStatus } from "app/pages/DiscountEditor/modules/Editor/state";

interface WarnOnUnsavedChangesProps {

}

interface StateProps {
    hasChanges: boolean
}

interface DispatchProps {
    
}

interface WarnState {
    eventListener: (evt: BeforeUnloadEvent) => void|string
}

type InternalProps = StateProps & DispatchProps

function unloadEventListener(this: WarnOnUnsavedChanges, evt: BeforeUnloadEvent) {
    if (!this.props.hasChanges)
        return;

    var confirmationMessage = "\o/";
    evt.returnValue = confirmationMessage;     
    return confirmationMessage;              
}

class WarnOnUnsavedChanges extends React.Component<InternalProps, WarnState> {
    constructor(props: InternalProps) {
        super(props);
        this.state = { eventListener: unloadEventListener.bind(this) };
    }

    render() {
        return true;
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.state.eventListener)
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.state.eventListener)
    }
}

function mapStateToProps(state: any, ownProps: WarnOnUnsavedChangesProps) : StateProps {
    return {
        hasChanges: getDiscountSaveStatus(state) == DiscountSaveStatus.ChangesToSave
    }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) : DispatchProps {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarnOnUnsavedChanges);
